import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Button,
  Tag,
  Text,
} from '@grupoboticario/flora-react';
import { BiDownload } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';
import { downloadOneFile, getCertificatesUrls } from 'utils/downloadUrls';
import { CertificatesDetails } from '../CertificateDetails';
import { DetailsButton, PanelContainer, Table } from './styles';

export function TableCertificates({
  certificates,
  selected,
  handleSelect,
}: any) {
  const { cpId } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );

  async function handleDownload(id: any, franshiceCode?: any) {
    try {
      const filesUrl = await getCertificatesUrls(cpId, franshiceCode, [id]);
      if (filesUrl) {
        filesUrl.map((item: any) => downloadOneFile(item));
      }
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <Accordion collapsible type="single">
      <Table>
        {certificates?.response.map((certificate: any) => {
          return (
            <AccordionItem
              value={`${certificate.id}`}
              as="tbody"
              key={certificate.id}
            >
              <tr>
                <td aria-label="Tabela">
                  <input
                    key={certificate.id}
                    type="checkbox"
                    id={certificate.id}
                    value={certificate.id}
                    onChange={() =>
                      handleSelect(certificate.id, certificate.pdvNumber)
                    }
                    checked={selected.some(
                      selection =>
                        selection.certificate === certificate.id &&
                        selection.code === certificate.pdvNumber,
                    )}
                  />
                </td>
                <td style={{ paddingLeft: '2rem' }}>
                  <Text
                    size="bodyMediumShort"
                    title={certificate.pdvNumber}
                    isTruncated
                  >
                    {certificate.pdvNumber}
                  </Text>
                </td>
                <td>
                  <Text
                    size="bodyMediumShort"
                    title={certificate.typeCertificate}
                    isTruncated
                  >
                    {certificate.typeCertificate}
                  </Text>
                </td>
                <td>
                  <Text size="bodyMediumShort">
                    <Tag variant="assorted9" as="span">
                      {certificate.period}
                    </Tag>
                  </Text>
                </td>
                <td>
                  <Text size="bodyMediumShort">
                    {certificate.files.fileName}
                  </Text>
                </td>
                <td aria-label="Download">
                  <Button
                    aria-label="button-download"
                    onClick={() =>
                      handleDownload(certificate.id, certificate.pdvNumber)
                    }
                    has="iconOnly"
                    size="small"
                    hierarchy="tertiary"
                    icon={<BiDownload />}
                  />
                </td>
                <DetailsButton>
                  {certificate.files.length > 1 && <AccordionButton />}
                </DetailsButton>
              </tr>

              {certificate.files.length > 1 && (
                <tr>
                  <PanelContainer colSpan={12}>
                    <AccordionPanel>
                      <CertificatesDetails
                        files={certificate?.files}
                        idCertificate={certificate.id}
                        pdvNumber={certificate.pdvNumber}
                        typeCertificate={certificate.typeCertificate}
                      />
                    </AccordionPanel>
                  </PanelContainer>
                </tr>
              )}
            </AccordionItem>
          );
        })}
      </Table>
    </Accordion>
  );
}
